export enum LogoAndTitleUploadDialogTypeEnum {
  STUDIO_LOGO = 'STUDIO_LOGO',
  STUDIO_TITLE = 'STUDIO_TITLE',
  EVENT_TITLE = 'EVENT_TITLE',
  COURSE_TITLE = 'COURSE_TITLE'
}
